// Get raw API URL from environment
const RAW_API_URL = process.env.REACT_APP_API_URL || '';

// Normalize API URL - remove trailing /api if present to prevent double /api/api/ prefix
// This ensures consistent URL construction regardless of how REACT_APP_API_URL is set
const normalizeAPIURL = (url) => {
  if (!url) return url;
  // Remove trailing /api to prevent double prefix when paths already include /api
  return url.replace(/\/api\/?$/, '');
};

// Normalized API URL (base URL without /api suffix)
const API_URL = normalizeAPIURL(RAW_API_URL);

// Helper function to build API URLs correctly
// Ensures we never get double /api/api/ prefix
export const buildAPIUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  // Build URL
  let url = `${API_URL}/${cleanPath}`;
  // Safety check: Fix double /api/api/ prefix if it exists
  url = url.replace(/\/api\/api\//g, '/api/');
  return url;
};

export default API_URL;
